// Game(kit) imports
import LibraryTypeEnum from '../../Game/Base/Library/Enums';

const defaultState = {
    id: '',
    position: { x: '', y: '' },
    size: { width: '', height: '' },
    type: LibraryTypeEnum.TEXTURES,
    active: false,
    currentAsset: '',
    onPickerClose: () => {},
    onPickAsset: assetData => {
        console.warn('No callback has been set for AssetsPopup.handlePickAsset');
    }
};

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case 'AP_OPEN': {
            const { payload } = action;
            const { identifier, pos, pickerSize, assetType, curAsset, handlePickerClose, handlePickAsset } = payload;

            return {
                ...state,
                id: identifier,
                position: pos,
                size: pickerSize,
                type: assetType,
                active: true,
                currentAsset: curAsset,
                onPickerClose: handlePickerClose,
                onPickAsset: handlePickAsset
            };
        }
        case 'AP_CLOSE': {
            return { ...defaultState, history: state.history };
        }
        case 'AP_SET_TRANSFORMATION': {
            const { payload } = action;

            return {
                ...state,
                size: payload.size,
                position: payload.position
            };
        }
        case 'AP_SET_CURRENT_ITEM': {
            return {
                ...state,
                currentAsset: action.payload
            };
        }
        default: {
            return state;
        }
    }
}
